module.exports = __webpack_public_path__ + "static/6m-4ea2fa414952213e121268ec28b1551a.jpg";